<template>
	<div class="care-setting">
		<van-cell title="用户协议" is-link
			url="https://r.piseneasy.com/pro/sysAgreement?SysNo=985218761621508096"></van-cell>
		<van-cell title="隐私协议" is-link
			url="https://r.piseneasy.com/pro/sysAgreement?SysNo=985218824447987712"></van-cell>
		<van-cell title="注销账号" is-link to="/care/setting/accountcancellation" v-if="islogin" />
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Cell
	} from "vant";

	Vue.use(Cell);
	export default {
		name: "CareSetting",
		data() {
			return {

			};
		},
		computed: {
			islogin() {
				const info = this.$store.state.userInfo;
				if (info) {
					// login(this.$store, this.$router);
					return true;
				} else {
					return false;
				}

			}
		},
		created() {

		},
		methods: {}
	};
</script>
<style lang="less" scoped>
	.care-setting {
		padding: 12px 12px 60px;
		min-height: 100vh;
		background-color: #f4f4f4;
		box-sizing: border-box;
	}
</style>